import React, { createContext, useContext, useState, useEffect, useCallback } from 'react';

const STORAGE_KEY = 'yournest_analytics_consent';

const CookieConsentContext = createContext(null);

export function useCookieConsent() {
  const context = useContext(CookieConsentContext);
  if (!context) {
    throw new Error('useCookieConsent must be used within a CookieConsentProvider');
  }
  return context;
}

export function CookieConsentProvider({ children }) {
  const [consent, setConsentState] = useState(null);

  useEffect(() => {
    try {
      const stored = localStorage.getItem(STORAGE_KEY);
      if (stored === 'accepted' || stored === 'declined') {
        setConsentState(stored);
      }
    } catch {
      // ignore
    }
  }, []);

  const setConsent = useCallback((value) => {
    setConsentState(value);
    try {
      if (value) localStorage.setItem(STORAGE_KEY, value);
    } catch {
      // ignore
    }
  }, []);

  const value = {
    consent,
    setConsent,
    hasAnalyticsConsent: consent === 'accepted',
  };

  return (
    <CookieConsentContext.Provider value={value}>
      {children}
    </CookieConsentContext.Provider>
  );
}
